<template>
  <form-input
    :label="labelComputed"
    v-model="internalText"
    type="textarea"
    cols="7"
    cols-help="3"
    height="230"
  >
    <template v-slot:help-text>
      <p>{{ trans('emailSettings.availableTemplateVariables') }}:</p>
      <div><span class="font-weight-bold">{Eigentümer}</span> - {{ trans('settlement.ownerName') }}</div>
      <div><span class="font-weight-bold">{AbrechnungMonatJahr}</span> - {{ trans('settlement.monthYearHelp') }}</div>
      <div><span class="font-weight-bold">{ObjektName}</span> - {{ trans('settlement.objectName') }}</div>
      <div><span class="font-weight-bold">{ObjektStrasse}</span> - {{ trans('settlement.objectStreet') }}</div>
      <div><span class="font-weight-bold">{ObjektPostleitzahl}</span> - {{ trans('settlement.objectZipcode') }}</div>
      <div><span class="font-weight-bold">{ObjektOrt}</span> - {{ trans('settlement.objectCity') }}</div>
    </template>
    <template v-slot:content-append>
      Mit freundlichen Grüßen<br>
      {{ closingName }}
      <slot name="content-append"></slot>
    </template>
  </form-input>
</template>

<script>
import FormInput from '@/components/FormInput';
import {LocaleUtils} from '@/utils/locale-utils';

export default {
  name: 'FormInputTemplateSettlementCoverLetter',
  mixins: [
    LocaleUtils
  ],
  components: {
    FormInput
  },
  props: {
    text: {
      type: String
    },
    closingName: {
      type: String
    },
    label: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      internalText: null
    }
  },
  computed: {
    labelComputed () {
      return this.label
        ? this.label
        : this.trans('userSettings.settlementTemplateCoverLetter')
      ;
    }
  },
  watch: {
    text: {
      immediate: true,
      handler () {
        this.internalText = this.text;
      }
    },
    internalText () {
      this.$emit('update:text', this.internalText);
    }
  }
}
</script>

<style scoped>

</style>
